import apiClient from './client';

// V48: una riga CER ammessa in area (id + fonte del dominio).
export type FonteCer = 'attivo' | 'eow' | 'rifiuto';

export interface MaterialeAmmesso {
  id: string;
  cer: string;
  nome_descrittivo: string | null;
  fonte: FonteCer;
}

export interface MaterialeAmmessoRef {
  id: string;
  fonte: FonteCer;
}

export interface Area {
  id: string;
  codice: string;
  descrizione: string;
  categoria: 'R13' | 'EoW' | 'DT' | 'RP';
  capacita_kg: number;
  cer_ammessi: string[];               // codici distinti derivati (display)
  materiali_ammessi: MaterialeAmmesso[];  // righe ammesse (V48)
  attiva: boolean;
  created_at: string;
  updated_at: string;
}

export interface AreaCapacita {
  area_id: string;
  capacita_kg: number;
  peso_attuale_kg: number;
  percentuale_utilizzo: number;
  warning: boolean;
}

export interface AreaIn {
  codice: string;
  descrizione: string;
  categoria: 'R13' | 'EoW' | 'DT' | 'RP';
  capacita_kg: number;
  materiali_ammessi: MaterialeAmmessoRef[];
  attiva?: boolean;
}

export async function listAreas(includeInactive = false): Promise<Area[]> {
  const res = await apiClient.get('/api/areas', {
    params: includeInactive ? { include_inactive: true } : {},
  });
  return res.data;
}

export async function getArea(id: string): Promise<Area> {
  const res = await apiClient.get(`/api/areas/${id}`);
  return res.data;
}

export async function createArea(body: AreaIn): Promise<Area> {
  const res = await apiClient.post('/api/areas', body);
  return res.data;
}

export async function updateArea(id: string, body: Partial<AreaIn>): Promise<Area> {
  const res = await apiClient.patch(`/api/areas/${id}`, body);
  return res.data;
}

export async function deleteArea(id: string): Promise<void> {
  await apiClient.delete(`/api/areas/${id}`);
}

export async function getAreaCapacita(id: string): Promise<AreaCapacita> {
  const res = await apiClient.get(`/api/areas/${id}/capacita-attuale`);
  return res.data;
}

export interface AreaSaldo {
  materiale: string;
  saldo_kg: number;
}

// Saldi per-materiale dell'area (solo saldo>0): per il prelievo mobile.
export async function getAreaSaldi(id: string): Promise<AreaSaldo[]> {
  const res = await apiClient.get(`/api/areas/${id}/saldi`);
  return res.data;
}
